const EmptyPagesIcon = (props) => (
  <span className="emptyProjectsIcon">
    <svg width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M106.667 16H21.3337C15.467 16 10.667 20.8 10.667 26.6667V101.333C10.667 107.2 15.467 112 21.3337 112H106.667C112.534 112 117.334 107.2 117.334 101.333V26.6667C117.334 20.8 112.534 16 106.667 16ZM106.667 101.333H21.3337V26.6667H106.667V101.333Z" fill="#111111" fillOpacity="0.2"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M103.52 55.5733L95.9467 48L79.04 64.9067L71.52 57.3333L64 64.8533L79.04 80L103.52 55.5733Z" fill="#111111" fillOpacity="0.2"/>
      <path d="M53.3337 37.3333H26.667V48H53.3337V37.3333Z" fill="#111111" fillOpacity="0.2"/>
      <path d="M53.3337 58.6667H26.667V69.3334H53.3337V58.6667Z" fill="#111111" fillOpacity="0.2"/>
      <path d="M53.3337 80H26.667V90.6667H53.3337V80Z" fill="#111111" fillOpacity="0.2"/>
    </svg>
  </span>
)

export default EmptyPagesIcon